/* istanbul ignore file */
import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, spacing } = theme;

const primaryRegularFont = css`
  font-family: ${fonts.PRIMARY_REGULAR.family};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
`;

export const label = css`
  ${theme.responsiveText.BODY.XS};
  color: var(--neutral-black-base);
  display: block;
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  margin-bottom: ${spacing.xs}px;
  padding: 0 ${pxToRem(20)} 0 0;
`;

export const labelScreenReaderOnly = css`
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(50%);
  height: 1px;
  width: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
`;

export const description = css`
  ${theme.responsiveText.BODY.XS};
  ${primaryRegularFont};
  color: var(--neutral-black-base);
  margin: 0 0 -${spacing.xs}px 0;
  padding: 0 ${pxToRem(20)} ${spacing.xs}px 0;
`;

export const wrapper = css`
  position: relative;
  padding: 0;
`;

export const fieldFeedbackContainer = css`
  display: flex;
  margin-top: ${spacing.xs}px;
`;

export const input = css`
  ${primaryRegularFont};
  ${theme.responsiveText.BODY.MD};
  /* iOS Safari zooms the page when focusing a field smaller than 16px */
  font-size: 1rem;
  border: solid ${pxToRem(1)} var(--neutral-black-70);
  border-radius: ${pxToRem(10)};
  color: var(--neutral-black-base);
  display: block;
  overflow: hidden;
  padding: ${pxToRem(9)} ${pxToRem(16)};
  resize: none;
  transition: border-color 0.15s ease-in, background-color 0.15s ease-in;
  width: 100%;
  appearance: none;

  [data-has-error='true'] & {
    background-color: var(--tertiary-red-50);
    border-color: var(--functional-red-base);
  }

  [data-is-valid='true'] & {
    background-color: var(--tertiary-green-50);
    border-color: var(--functional-green-base);
  }

  [data-has-error='false'][data-is-valid='false'] &:hover {
    border-color: var(--neutral-black-base);
  }

  [data-has-error='false'][data-is-valid='false'] &:focus {
    border-color: var(--brand-purple-base);
  }

  &::placeholder {
    color: var(--neutral-black-70);
  }
`;
